module.exports = __webpack_public_path__ + "sy.svg?0d56cb2b5bea91512b7bc643d5594994";